"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResponsiveSpacingStyles = void 0;
var _responsiveSpacing = require("../styles/responsiveSpacing");
var _isRtl = require("./isRtl");
var _linaria = require("./linaria");
const spacingStyles = {
  desktop: _responsiveSpacing.desktopStyles,
  tablet: _responsiveSpacing.tabletStyles,
  phone: _responsiveSpacing.phoneStyles
};
const getResponsiveSpacingStyles = (device, spacing, value, isInverted) => {
  const spacingClasses = [];
  const style = isInverted ? 'margin' : 'padding';
  const deviceStyles = spacingStyles[device][style];
  if (spacing === 'spacing' || spacing === 'offset') {
    spacingClasses.push(deviceStyles.all[value]);
  }
  if (spacing.endsWith('Vertical')) {
    spacingClasses.push(deviceStyles.top[value]);
    spacingClasses.push(deviceStyles.bottom[value]);
  }
  if (spacing.endsWith('Horizontal')) {
    spacingClasses.push(deviceStyles.left[value]);
    spacingClasses.push(deviceStyles.right[value]);
  }
  if (spacing.endsWith('Top')) {
    spacingClasses.push(deviceStyles.top[value]);
  }
  if (spacing.endsWith('Bottom')) {
    spacingClasses.push(deviceStyles.bottom[value]);
  }
  if (spacing.endsWith('Start')) {
    if ((0, _isRtl.isRtl)()) {
      spacingClasses.push(deviceStyles.right[value]);
    } else {
      spacingClasses.push(deviceStyles.left[value]);
    }
  }
  if (spacing.endsWith('End')) {
    if ((0, _isRtl.isRtl)()) {
      spacingClasses.push(deviceStyles.left[value]);
    } else {
      spacingClasses.push(deviceStyles.right[value]);
    }
  }
  return (0, _linaria.cx)(...spacingClasses);
};
exports.getResponsiveSpacingStyles = getResponsiveSpacingStyles;